import { FC, useContext } from 'react';
import { AddonProps } from './type';
import formatPriceForDisplay from '../../../../utils/formatPriceForDisplay';
import AmountButton from './AmountButton';
import { AppContext } from '../../../../AppContext';

const Addon: FC<AddonProps> = ({ id, totalPrice, title }) => {
  const { chosenAddonsState } = useContext(AppContext);
  const [chosenAddons] = chosenAddonsState;
  const description = '';
  const amount = chosenAddons?.filter((cA: string) => cA === id).length;

  return (
    <div
      style={{
        borderBottom: '1px solid #f0f0f0',
        padding: '10px 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h3 style={{ margin: 0 }}>{title || id}</h3>
        <AmountButton id={id} amount={amount} price={totalPrice} />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <p className='small-grey-text'>{description}</p>
          <p className='small-grey-text'>
            CHF {totalPrice ? formatPriceForDisplay(totalPrice) : '-'}
          </p>
        </div>
        <span className='amount-counter-total-price'>
          CHF {totalPrice ? formatPriceForDisplay(totalPrice * amount) : '-'}
        </span>
      </div>
    </div>
  );
};

export default Addon;
